<div class="modal-body p-0 flex-fill d-flex flex-column compact-form" *ngIf="!!orderLineDetails">
    <div class="row">
        <div class="col-sm-8" style="padding-right: 0px">
            <div class="m-1 dark-group">
                <dx-data-grid
                    #dataGrid
                    [dataSource]="orderLineDetails"
                    keyExpr="id"
                    height="800px"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onSelectionChanged)="selectionChange($event)"
                    (onRowPrepared)="rowPrepare($event)"
                    (onCellDblClick)="rowDoubleClick($event)"
                    (onRowUpdated)="onRowUpdating($event, dataGrid)"
                >
                    <dxi-column dataField="orderLine.order.invoiceNumber" caption="Order #" width="80" cellTemplate="linkTemplate" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="orderLine.order.pONumber" caption="PO #" width="80" cellTemplate="linkTemplate" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="orderLine.order.dealer.companyName" caption="Dealer" width="100" [allowEditing]="false" [sortIndex]="0" sortOrder="asc"></dxi-column>
                    <dxi-column dataField="orderLine.order.shipToCity" caption="City" width="100" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="orderLine.order.shipToState" caption="State" width="45" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" [allowEditing]="false" width="65"></dxi-column>
                    <dxi-column dataField="orderLine.partNumber" caption="Part #" width="125" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="vIN" caption="Vin #" width="100" [allowEditing]="true"></dxi-column>
                    <dxi-column dataField="status.name" caption="Status" width="100" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="orderLine.order.createDate" caption="Order Date" width="100" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="dueDate" caption="Due Date" width="100" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="deliveryOption.name" caption="Delivery" width="100" [allowEditing]="false"></dxi-column>
                    <dxi-column></dxi-column>

                    <dxo-group-panel [visible]="true"></dxo-group-panel>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-selection mode="multiple"></dxo-selection>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="orderlinedetail-setup-grid"></dxo-state-storing>
                    <dxo-sorting mode="multiple"></dxo-sorting>
                    <dxo-editing [mode]="'cell'" [allowUpdating]="canEditGrid"></dxo-editing>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

                    <div *dxTemplate="let cell of 'linkTemplate'">
                        <a [routerLink]="[]" (click)="open(cell.data.orderLine.orderId)">{{ cell.value || '' }}</a>
                    </div>
                    <div *dxTemplate="let data of 'toolbarButtonsBefore'">
                        <!-- <button type="button" class="btn btn-success ms-2" (click)="open()">New</button>
                        <button
                            type="button"
                            class="btn btn-secondary ms-2"
                            [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1 || !!dataGrid.instance.getSelectedRowsData()[0].deleted"
                            [hidden]="showAsDialog || !auth.hasRole('Orders')"
                            (click)="open(dataGrid.instance.getSelectedRowsData()[0].orderId)"
                        >
                            Open
                        </button> -->

                        <!-- <button type="button" class="btn btn-sm btn-warning ms-2" (click)="toggleCompleted()">
                            {{ showCompleted ? 'Hide Non-Active' : 'Show All' }}
                        </button> -->
                    </div>
                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button
                            type="button"
                            class="btn btn-success ms-2"
                            (click)="addToProduction(dataGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                        >
                            Add
                        </button>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span *ngIf="orderLineDetails" class="me-3"
                            ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                        >
                    </div>
                </dx-data-grid>
            </div>
        </div>
        <div class="col-sm-4" style="padding-left: 10px">
            <div class="m-1 mb-3">
                <dx-form [formData]="filter" validationGroup="mainValidationGroup" style="max-width: 500px">
                    <dxi-item [label]="{ text: 'Jig' }" *ngIf="filter">
                        <div *dxTemplate class="d-flex">
                            <div class="flex-fill">
                                <dx-select-box [(value)]="filter.jigId" [items]="jigs" [valueExpr]="'id'" [displayExpr]="'name'" (onValueChanged)="prioritySelectionChange($event)"> </dx-select-box>
                            </div>
                            <!-- <button
                                type="button"
                                (click)="priorityChange(-1)"
                                class="btn btn-sm btn-secondary ms-4 me-2"
                                style="min-width: 100px"
                                [disabled]="filter.priority === 1"
                            >
                                Previous
                            </button>
                            <button type="button" (click)="priorityChange(1)" class="btn btn-sm btn-secondary" style="min-width: 100px" [disabled]="filter.priority === 9">
                                Next
                            </button> -->
                        </div>
                    </dxi-item>
                    <dxi-item [label]="{ text: 'Run Date' }" *ngIf="filter">
                        <div *dxTemplate class="d-flex">
                            <div class="flex-fill">
                                <dx-date-box [(value)]="filter.runDate" (onValueChanged)="prioritySelectionChange($event)"> </dx-date-box>
                            </div>
                            <button type="button" (click)="dateChange(-1)" class="btn btn-sm btn-secondary ms-4 me-2" style="min-width: 100px">Previous</button>
                            <button type="button" (click)="dateChange(1)" class="btn btn-sm btn-secondary" style="min-width: 100px">Next</button>
                        </div>
                    </dxi-item>
                </dx-form>

                <dx-data-grid
                    class="mt-1 me-4 production-data-grid"
                    *ngIf="schedules"
                    #productionsGrid
                    [dataSource]="schedules"
                    keyExpr="id"
                    height="720px"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [sorting]="'none'"
                    (onToolbarPreparing)="onSecondaryToolbarPreparing($event)"
                    (onRowPrepared)="rowPrepareProduction($event)"
                    (onRowUpdated)="onRowUpdating($event, productionsGrid)"
                >
                    <dxi-column
                        dataField="jigId"
                        caption="Jig #"
                        width="70"
                        [sortIndex]="0"
                        [sortOrder]="'asc'"
                        [allowEditing]="allowReordering && filter.priority !== 1"
                    ></dxi-column>
                    <dxi-column dataField="displayName" caption="OrderLine" width="350" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="completed" caption="Complete" width="75" [allowEditing]="false"></dxi-column>
                    <!-- <dxi-column dataField="orderLine.remainingQty" caption="Remain" width="75" [allowEditing]="false"></dxi-column> -->
                    <dxi-column width="45"></dxi-column>

                    <dxo-selection mode="multiple"></dxo-selection>
                    <dxo-editing [mode]="'cell'" [allowUpdating]="false"></dxo-editing>
                    <dxo-row-dragging [allowReordering]="allowReordering" [onReorder]="onReorder" [showDragIcons]="true"></dxo-row-dragging>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button
                            type="button"
                            class="btn btn-sm btn-secondary ms-2"
                            [disabled]="productionsGrid.instance.getSelectedRowsData().length !== 1"
                            (click)="removeProduction(productionsGrid.instance.getSelectedRowsData()[0])"
                        >
                            Remove
                        </button>
                        <button type="button" class="btn btn-sm btn-success ms-4" [disabled]="productionsGrid.instance.getSelectedRowsData().length === 0" (click)="complete()">
                            Complete
                        </button>
                        <!-- <button
                            type="button"
                            class="btn btn-sm btn-primary ms-2"
                            [disabled]="productionsGrid.instance.getSelectedRowsData().length !== 1"
                            (click)="completePartial()"
                        >
                            Add Partial
                        </button> -->
                        <button type="button" class="btn btn-sm btn-success ms-4" (click)="print(0)">Print Schedule</button>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'"></div>
                </dx-data-grid>
            </div>
        </div>
    </div>
</div>
